import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addCountry,
  deleteCountry,
  getCountry,
  updateCountry,
  updateDefaultCountry,
} from "store/services/dataManagement/country";
import { uploadFile } from "store/services/utilities";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

//Get All country
export const GetAllCountryAction = createAsyncThunk(
  "country/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getCountry(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

//Delete country
export const DeleteCountryAction = createAsyncThunk(
  "country/delete",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, onSuccess, onError, ...rest } = payload;
      const res = await deleteCountry(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        const responce = await getCountry(filter);
        if (responce.status === 1) {
          if (onSuccess) {
            onSuccess(responce);
          }
          return fulfillWithValue(responce);
        }
      }
      if (onError) {
        onError();
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

//Update country
export const UpdateCountryAction = createAsyncThunk(
  "country/update",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    let { file, onSuccess, onError, ...rest } = payload;
    try {
      if (file) {
        const uploadFilesResponse = await uploadFile({
          file: file,
          uploadFor: "image",
        });

        if (uploadFilesResponse.status === 0) {
          dispatch(
            openToast({ type: "error", message: uploadFilesResponse?.message }),
          );
          return rejectWithValue(uploadFilesResponse);
        }
        rest.image = uploadFilesResponse.response.urls[0];
      }
      const res = await updateCountry(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        if (onSuccess) {
          onSuccess();
        }
        dispatch(closeAdminModal());
        return fulfillWithValue(res);
      }
      if (onError) {
        onError();
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      if (onError) {
        onError();
      }
      return rejectWithValue(error);
    }
  },
);

//Update country
export const UpdateDefaultCountryAction = createAsyncThunk(
  "country/updateDefault",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await updateDefaultCountry(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data

        dispatch(closeAdminModal());
        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

// Add country
export const AddCountryAction = createAsyncThunk(
  "country/add",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { file, onSuccess, onError, ...rest } = payload;

    try {
      // Upload image
      if (file) {
        const uploadFilesResponse = await uploadFile({
          file: file,
          uploadFor: "image",
        });

        if (uploadFilesResponse.status === 0) {
          dispatch(
            openToast({
              type: "error",
              message: uploadFilesResponse?.message,
            }),
          );

          if (onError) {
            onError(uploadFilesResponse);
          }

          return rejectWithValue(uploadFilesResponse);
        }

        rest.image = uploadFilesResponse.response.urls[0];
      }

      // Add country API
      const res = await addCountry(rest);

      if (res.status === 1) {
        if (onSuccess) {
          onSuccess(res);
        }

        dispatch(closeAdminModal());
        dispatch(GetAllCountryAction());

        return fulfillWithValue(res);
      }

      // Error response
      if (onError) {
        onError(res);
      }

      // Status code based message
      if (res?.statusCode === 7) {
        dispatch(
          openToast({
            type: "error",
            message: "Country already exists",
          }),
        );
      } else {
        dispatch(
          openToast({
            type: "error",
            message: getApiMessage(res?.statusCode),
          }),
        );
      }

      return rejectWithValue(res);
    } catch (error) {
      const errorResponse = error?.response?.data;

      if (onError) {
        onError(errorResponse);
      }

      if (errorResponse?.statusCode === 7) {
        dispatch(
          openToast({
            type: "error",
            message: "Country already exists",
          }),
        );
      } else {
        dispatch(
          openToast({
            type: "error",
            message: errorResponse?.statusCode
              ? getApiMessage(errorResponse.statusCode)
              : error?.message,
          }),
        );
      }

      return rejectWithValue(errorResponse || error);
    }
  },
);
